import React from 'react'

import Button from '@react/react-spectrum/Button'
import FieldLabel from '@react/react-spectrum/FieldLabel'
import Heading from '@react/react-spectrum/Heading'
import Help from '@react/react-spectrum/Icon/Help'
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Select from '@react/react-spectrum/Select'
import Textfield from '@react/react-spectrum/Textfield'
import Tooltip from '@react/react-spectrum/Tooltip'

import LocalePicker from 'components/LocalePicker'

import SettingsSwitch from '../SettingsSwitch'

import { MOBILE as config } from 'config/projects/mobile'

export function MobileSettings({ settings, disabled, onChange }) {
  const inboxOptions = config.displayInboxOptions || []
  const displayInbox =
    settings.displayInbox || inboxOptions?.find((opt) => opt.default)?.value || inboxOptions[0]?.value

  const defaultCartStorage = config.cartStorageOptions?.find((o) => o.default)?.value || 'local'

  const _onChange = (propName) => (v) => !disabled && onChange(propName)(v)

  return (
    <>
      <section>
        <Heading size='4'>General</Heading>

        <FieldLabel label='Locale' labelFor='locale'>
          <LocalePicker value={settings.locale} onChange={_onChange('locale')} disabled={disabled} />
          <OverlayTrigger placement='right'>
            <Button className='tooltip-btn' variant='tool' icon={<Help />} />
            <Tooltip>
              Select or type in language/currency locale. Delete field content to see the full list of common options.
            </Tooltip>
          </OverlayTrigger>
        </FieldLabel>
      </section>

      <em>
        Navigation and authentication-related settings
        <br />
        have been moved to Navigation tab.
      </em>

      <section>
        <Heading size='4'>Cart</Heading>
        <SettingsSwitch label='Use Cart' checked={settings.useCart} onChange={_onChange('useCart')} />

        {settings.useCart && config.cartStorageOptions?.length > 0 && (
          <FieldLabel label='Cart Storage' labelFor='cartStorage'>
            <Select
              options={config.cartStorageOptions}
              value={settings.cartStorage || defaultCartStorage}
              id='cartStorage'
              onChange={_onChange('cartStorage')}
              disabled={disabled}
            />
          </FieldLabel>
        )}
      </section>

      <section>
        <Heading size='4'>Inbox</Heading>

        <FieldLabel label='Inbox location' labelFor='displayInbox'>
          <Select
            options={config.displayInboxOptions}
            value={displayInbox}
            id='displayInbox'
            onChange={_onChange('displayInbox')}
            disabled={disabled}
          />
        </FieldLabel>
      </section>

      <section>
        <Heading size='4'>Accepted Offers</Heading>
        <SettingsSwitch
          label='Display in Inbox'
          checked={!!settings.enableAcceptedOffers}
          onChange={_onChange('enableAcceptedOffers')}
        />

        {/* <Heading size='4'>Beacons</Heading>
        <SettingsSwitch
          label='Block automatic monitoring'
          checked={!!settings.beaconsBlockAutoListen}
          onChange={_onChange('beaconsBlockAutoListen')}
        /> */}
      </section>

      <section>
        <Heading size='4'>Target</Heading>
        <SettingsSwitch
          label='Target Recommendations'
          checked={!!settings.enableTargetRec}
          onChange={_onChange('enableTargetRec')}
        />

        <FieldLabel label='Mbox Name' labelFor='targetRecMboxName'>
          <Textfield
            id='enableTargetRec'
            value={(settings.enableTargetRec && settings.targetRecMboxName) || ''}
            onChange={_onChange('targetRecMboxName')}
            disabled={disabled || !settings.enableTargetRec}
          />
        </FieldLabel>
      </section>
    </>
  )
}
